'use strict';

import { resetDropdown } from '../helpers/accessibility';

// TODO: move this into a resetDropdown call in site.js
const infoCardDropdown = (function() {
  function init() {
    resetDropdown('.information-cards', '#js-dropdown');
  }
  window.addEventListener('DOMContentLoaded', () => {
    const navEl = document.getElementById('js-dropdown');
    if (navEl) init();
  });
})();

export default infoCardDropdown;
